import React, { useState, useEffect } from 'react';
import * as styles from './table.module.scss';
import DatePicker from "react-datepicker";
import MediaQuery from 'react-responsive';

import "react-datepicker/dist/react-datepicker.css";
import cloneDeep from 'lodash.clonedeep';

const TableFilter = (props) => {
    const {id, itemsFilter, getFilteredItems} = props;
    
    const [filter, setFilter] = useState({});

    useEffect(() => {
        let filter = {};
        Object.keys(itemsFilter.filterProps).forEach(key => {
            let prop = itemsFilter.filterProps[key];
            if (prop.type === "dates") {
                filter[prop.dateFrom.name] = prop.dateFrom.value;
                filter[prop.dateTo.name] = prop.dateTo.value;
            } else {
                filter[prop.name] = prop.value;
            }
            
        });

        setFilter(filter);
    }, [id])

    const applyFilter = () => {
        let f = {...itemsFilter.modelFilter, ...filter};
        getFilteredItems(f);
    }

    const onPropertyChanged = (propName, propValue) => {
        let newFilter = cloneDeep(filter);
        newFilter[propName] = propValue;
        setFilter(newFilter);
    }

    const renderCombobox = (prop) => {
        let value = filter[prop.name] || prop.header;

        return (
            <div key={prop.name} className={styles.input_container}>
                <select value={value} onChange={(e) => onPropertyChanged(prop.name, e.target.value)}>
                    {
                        prop.options.map((opt, index) =>
                            <option key={index} value={opt.value}>{ opt.name }</option>
                        )
                    }
                </select>
            </div>
        );
    }

    const renderString = (prop)=> {
        return (
            <div key={prop.name} className={styles.input_container}>
                <input type="text" placeholder={prop.header} value={filter[prop.name] || ""} onChange={(e) => onPropertyChanged(
                    prop.name,
                    e.target.value)}/>
            </div>
        );
    }

    const renderInt = (prop) => {
        return (
            <div key={prop.name} className={styles.input_container}>
                <input type="number" placeholder={prop.header} value={filter[prop.name] || ""} onChange={(e) => onPropertyChanged(
                    prop.name,
                    e.target.value)}/>
            </div>
        );
    }    

    const renderDates = (prop) => {
        let dateFromName = prop.dateFrom.name;
        let dateToName = prop.dateTo.name;

        return (
            <div key={prop.name} className={styles.dates_input_container}>
                <MediaQuery minDeviceWidth={1224}>
                    <div className={styles.date_picker}><DatePicker selected={filter[dateFromName]} onChange={date =>
                        onPropertyChanged(dateFromName, date)}
                        placeholderText={prop.dateFrom.header} /></div>
                    <div className={styles.date_picker}><DatePicker selected={filter[dateToName]} onChange={date =>
                        onPropertyChanged(dateToName, date)}
                        placeholderText={prop.dateTo.header}/></div>
                </MediaQuery>
            <MediaQuery maxDeviceWidth={1224}>
                    <div className={styles.date_picker}><DatePicker selected={filter[dateFromName]} withPortal onChange={date =>
                        onPropertyChanged(dateFromName, date)}
                                placeholderText={prop.dateFrom.header}/></div>
                <div className={styles.date_picker}><DatePicker selected={filter[dateToName]} withPortal onChange={date =>
                        onPropertyChanged(dateToName, date)}
                                placeholderText={prop.dateTo.header}/></div>
                </MediaQuery>
            </div>
        );
    }

    return (
        <div className={styles.table_filter}>
            {
                Object.keys(itemsFilter.filterProps).map((key) => {
                    let prop = itemsFilter.filterProps[key];
                    if (prop.type === "select") {
                        return renderCombobox(prop);
                    }
                    else if (prop.type === "string") {
                        return renderString(prop);
                    }
                    else if (prop.type === "int") {
                        return renderInt(prop);
                    } else if (prop.type === "dates") {
                        return renderDates(prop);
                    }

                    return <></>;
                })
            }
            <button className={styles.filter_button_style} onClick={applyFilter}>Ok</button>    
        </div>
    );
}

export default TableFilter;

// export default class TableFilter extends React.Component {
//     constructor(props) {
//         super(props);

//         let filter = cloneDeep(props.itemsFilter.modelFilter);
//         Object.keys(props.itemsFilter.filterProps).map(key => {
//             let prop = props.itemsFilter.filterProps[key];
//             if (prop.type === "dates") {
//                 filter[prop.dateFrom.name] = prop.dateFrom.value;
//                 filter[prop.dateTo.name] = prop.dateTo.value;
//             } else {
//                 filter[prop.name] = prop.value;
//             }
            
//         });
//         this.state = filter;
//         this.onPropertyChanged = this.onPropertyChanged.bind(this);
//         this.applyFilter = this.applyFilter.bind(this);
//     }

//     applyFilter() {
//         this.props.getFilteredItems(this.state);
//     }

//     onPropertyChanged(propName, propValue) {
//         let filter = cloneDeep(this.state);
//         filter[propName] = propValue;
//         this.setState(filter);
//     }

//     renderCombobox(prop) {
//         let value = this.state[prop.name] || prop.header;

//         return (
//             <div key={prop.name} className={styles.input_container}>
//                 <select value={value} onChange={(e) => this.onPropertyChanged(prop.name, e.target.value)}>
//                     {
//                         prop.options.map((opt, index) =>
//                             <option key={index} value={opt.value}>{ opt.name }</option>
//                         )
//                     }
//                 </select>
//             </div>
//         );
//     }

//     renderString(prop) {
//         return (
//             <div key={prop.name} className={styles.input_container}>
//                 <input type="text" placeholder={prop.header} value={this.state[prop.name]} onChange={(e) => this.onPropertyChanged(
//                     prop.name,
//                     e.target.value)}/>
//             </div>
//         );
//     }

//     renderInt(prop) {
//         return (
//             <div key={prop.name} className={styles.input_container}>
//                 <input type="number" placeholder={prop.header} value={this.state[prop.name]} onChange={(e) => this.onPropertyChanged(
//                     prop.name,
//                     e.target.value)}/>
//             </div>
//         );
//     }    

//     renderDates(prop) {
//         let dateFromName = prop.dateFrom.name;
//         let dateToName = prop.dateTo.name;

//         return (
//             <div key={prop.name} className={styles.dates_input_container}>
//                 <MediaQuery minDeviceWidth={1224}>
//                     <div className={styles.date_picker}><DatePicker selected={this.state[dateFromName]} onChange={date =>
//                         this.onPropertyChanged(dateFromName, date)}
//                         placeholderText={prop.dateFrom.header} /></div>
//                     <div className={styles.date_picker}><DatePicker selected={this.state[dateToName]} onChange={date =>
//                         this.onPropertyChanged(dateToName, date)}
//                         placeholderText={prop.dateTo.header}/></div>
//                 </MediaQuery>
//             <MediaQuery maxDeviceWidth={1224}>
//                     <div className={styles.date_picker}><DatePicker selected={this.state[dateFromName]} withPortal onChange={date =>
//                         this.onPropertyChanged(dateFromName, date)}
//                                 placeholderText={prop.dateFrom.header}/></div>
//                 <div className={styles.date_picker}><DatePicker selected={this.state[dateToName]} withPortal onChange={date =>
//                         this.onPropertyChanged(dateToName, date)}
//                                 placeholderText={prop.dateTo.header}/></div>
//                 </MediaQuery>
//             </div>
//         );
//     }

//     render() {
//         return (
//             <div className={styles.table_filter}>
//                 {
//                     Object.keys(this.props.itemsFilter.filterProps).map((key) => {
//                         let prop = this.props.itemsFilter.filterProps[key];
//                         if (prop.type === "select") {
//                             return this.renderCombobox(prop);
//                         }
//                         else if (prop.type === "string") {
//                             return this.renderString(prop);
//                         }
//                         else if (prop.type === "int") {
//                             return this.renderInt(prop);
//                         } else if (prop.type === "dates") {
//                             return this.renderDates(prop);
//                         }
//                     })
//                 }
//                 <button className={styles.filter_button_style} onClick={this.applyFilter}>Ok</button>    
//             </div>
//         );
//     }
// }
